@if (province && formGroup) {
  <div class="province-detail-container" [formGroup]="formGroup">
    <p>
      {{ translationService.getSelectProductRecyclabilityStatusText() }}
      <span class="province-name">{{ province }}</span>
    </p>
    <mat-radio-group
      aria-labelledby="recyclabilityStatusRadioGroup"
      formControlName="recyclabilityStatus"
    >
      <mat-radio-button value="recyclable">{{
        translationService.getRecyclableText()
      }}</mat-radio-button>
      <mat-radio-button value="non-recyclable">{{
        translationService.getNonRecyclableText()
      }}</mat-radio-button>
      <mat-radio-button value="collected">{{
        translationService.getCollectedText()
      }}</mat-radio-button>
    </mat-radio-group>

    @if (submitted && formGroup.get('recyclabilityStatus')?.invalid) {
      <mat-error>{{
        translationService.getSelectRecyclabilityOptionText()
      }}</mat-error>
    }
  </div>
}
